import React, {useEffect, useState} from 'react';
import {connect} from 'react-redux';
import {getCustomers} from '../../store/customers/actions';
import {useFormContext, Controller} from 'react-hook-form';
import Select from 'react-select';

const ListCustomers = ({
  data,
  getCustomers,
  required = false,
  onChange,
  initialSelect = '',
}) => {
  const [customers, setCustomers] = useState([]);

  const {
    control,
    formState: {errors},
  } = useFormContext();

  useEffect(() => {
    getCustomers();
  }, [getCustomers]);

  useEffect(() => {
    if (data) {
      setCustomers(data);
    }
  }, [data]);

  // Transform customers into react-select format
  const options = customers.map((cust) => ({
    value: cust.id,
    label: cust.name,
    data: cust, // Keep full customer object
  }));

  // Find initial value
  const defaultValue = initialSelect ?
    options.find((opt) => String(opt.value) === String(initialSelect)) :
    null;

  function handleChange(selectedOption) {
    if (onChange) {
      onChange(selectedOption ? selectedOption.data : null);
    }
  }

  return (
    <Controller
      name="customer"
      control={control}
      defaultValue={defaultValue}
      rules={{
        required: required ? 'Please select a customer' : false,
      }}
      render={({field}) => (
        <div>
          <Select
            {...field}
            options={options}
            isClearable
            placeholder="Select customer"
            onChange={(selectedOption) => {
              field.onChange(selectedOption);
              handleChange(selectedOption);
            }}
            className="react-select-container"
            classNamePrefix="react-select"
          />
          {errors?.customer && (
            <p className="text-danger"><small>{errors.customer.message}</small></p>
          )}
        </div>
      )}
    />
  );
};

const mapStateToProps = (state) => {
  const {data} = state.Customers;
  return {data};
};

export default connect(mapStateToProps, {getCustomers})(ListCustomers);
